module.exports = __webpack_public_path__ + "static/media/habitat.43c3cf79.jpg";